import { Suspense, lazy } from 'react';
import { PartialRouteObject } from 'react-router';
import BaseLayout from 'src/app/shared/layouts/BaseLayout';
import SuspenseLoader from 'src/app/shared/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );
const Status404 = Loader(
  lazy(() => import('src/app/shared/content/pages/Status/Status404'))
);
// HomeV2 reemplaza al HomePage legacy: powerea / y /:tableId (entrada del comensal
// sin login / sin guestMode, antes de activar el modo invitado vía QR).
const HomeV2 = Loader(
  lazy(() => import('src/app/feature/HomeV2/pages/HomeV2Page'))
);
const Login = Loader(
  lazy(() => import('src/app/feature/Auth/Login/pages/Login'))
);
const Register = Loader(
  lazy(() => import('src/app/feature/Auth/Register/pages/Register'))
);
const PasswordRecovery = Loader(
  lazy(
    () => import('src/app/feature/Auth/PasswordRecovery/pages/PasswordRecovery')
  )
);

const routesAuth: PartialRouteObject[] = [
  {
    path: '*',
    element: <BaseLayout />,
    children: [
      // Orden: raíz exacta → estáticas → dinámicas con prefijo → /:tableId → 404.
      // react-router 6.0.0-beta.0 resuelve hermanas por orden de declaración (no por
      // especificidad), así que /:tableId DEBE ir lo más abajo posible: captura
      // cualquier segmento y si va antes se traga /login, /register, etc.
      // 1) Raíz exacta
      {
        path: '/',
        element: <HomeV2 />
      },
      // 2) Estáticas (sin parámetros)
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/register',
        element: <Register />
      },
      {
        path: '/passwordRecovery',
        element: <PasswordRecovery />
      },
      // 3) Dinámicas con prefijo estático
      {
        path: '/login/rest/:slug',
        element: <Login />
      },
      {
        path: '/register/rest/:slug',
        element: <Register />
      },
      {
        path: '/login/:tableId',
        element: <Login />
      },
      {
        path: '/register/:tableId',
        element: <Register />
      },
      {
        path: '/rest/:slug',
        element: <HomeV2 />
      },
      // 4) Raíz dinámica (la más genérica): justo arriba del catch-all
      {
        path: '/:tableId',
        element: <HomeV2 />
      },
      // 5) Catch-all
      {
        path: '*',
        element: <Status404 />
      }
    ]
  }
];

export default routesAuth;
